// src/theme.js
import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    palette: {
        mode: 'light',
        primary: { main: '#002F6C' },   // Depot Navy
        secondary: { main: '#C7A24D' }, // Pullman Gold
        background: { default: '#FFFFFF', paper: '#FFFFFF' },
        text: { primary: '#222', secondary: '#555' },
    },
    typography: {
        // Body text stays readable
        fontFamily:
            '"Source Sans 3", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", Arial, "Noto Sans"',
        h1: {
            fontFamily: '"Merriweather", Georgia, "Times New Roman", serif',
            fontWeight: 800,
            letterSpacing: 0.2,
            fontSize: '3.25rem',
        },
        h2: {
            fontFamily: '"Merriweather", Georgia, "Times New Roman", serif',
            fontWeight: 800,
            fontSize: '2.5rem',
        },
        h3: {
            fontFamily: '"Merriweather", Georgia, "Times New Roman", serif',
            fontWeight: 800,
            fontSize: '2rem',
        },
        h4: {
            fontFamily: '"Merriweather", Georgia, "Times New Roman", serif',
            fontWeight: 800,
            fontSize: '2rem',
        },
        h5: {
            fontFamily: '"Merriweather", Georgia, "Times New Roman", serif',
            fontWeight: 800,
        },
        body1: { fontSize: '1.3rem', lineHeight: 1.75 },
        body2: { fontSize: '1.2rem', lineHeight: 1.3 },
        button: { textTransform: 'none', fontWeight: 700 },
    },
    components: {
        MuiButton: {
            // Make "large" the default everywhere
            defaultProps: {
                size: 'large',
                disableElevation: false,
            },
            styleOverrides: {
                root: {
                    borderRadius: 10,
                    fontWeight: 700,
                },
                // Bigger touch targets + type on all sizes
                sizeSmall: {
                    padding: '10px 18px',
                    fontSize: '1rem',
                    minHeight: 40,
                },
                sizeMedium: {
                    padding: '12px 22px',
                    fontSize: '1.08rem',
                    minHeight: 44,
                },
                sizeLarge: {
                    padding: '14px 26px',
                    fontSize: '1.15rem',
                    minHeight: 48,
                },
                // Make icons scale with the larger buttons
                startIcon: {
                    marginLeft: -2,
                    marginRight: 8,
                    '& > *:nth-of-type(1)': { fontSize: '1.35em' },
                },
                endIcon: {
                    marginLeft: 8,
                    marginRight: -2,
                    '& > *:nth-of-type(1)': { fontSize: '1.35em' },
                },
            },
        },
        MuiIconButton: {
            // Slightly larger icon buttons (e.g., social icons)
            styleOverrides: {
                root: { padding: 10 },
                sizeLarge: { padding: 12 },
            },
        },
        MuiLink: {
            styleOverrides: {
                root: {
                    color: '#002F6C',
                    textUnderlineOffset: '3px',
                    '&:hover': { color: '#001F4C', textDecoration: 'underline' },
                },
            },
        },
        MuiCard: { styleOverrides: { root: { borderRadius: 12 } } },
    },
});

export default theme;
